import { useQuery } from 'react-query';
import ChatAPI from '../Api/chat';

export const useChatToken = (userId: string) =>
  useQuery(['chat-token', userId], () => ChatAPI.getChatToken(userId));
